import type { SomtagSlot } from "@src/interfaces";
import React, { useContext } from "react";
import { AdsContext } from '@src/context/ads';
import Somtag, { SomtagProps } from "@src/components/Ad/Somtag";

const LiveblogAd = ({ id, slot }: { id: string, slot: SomtagSlot }) => {
  const { somtagInitialized } = useContext(AdsContext);

  const component: SomtagProps = {
    id,
    slot,
    display: ['desktop', 'mobile'],
    type: 'somtag',
  }
  return (
    <div className="liveblog-post-ad">
      {somtagInitialized ? <Somtag {...component} /> : null}
    </div>
  );
};

export default LiveblogAd;
